export default {
    UPDATE_FSDO_STATE_OPTIONS: 'UPDATE_FSDO_STATE_OPTIONS',
    GET_FSDO_LOCATIONS_PENDING: 'GET_FSDO_LOCATIONS_PENDING',
    GET_FSDO_LOCATIONS_SUCCESS: 'GET_FSDO_LOCATIONS_SUCCESS',
    GET_FSDO_LOCATIONS_FAILURE: 'GET_FSDO_LOCATIONS_FAILURE',
    RESET_FSDO_LOAD_REQUEST: 'RESET_FSDO_LOAD_REQUEST',
    FSDO_SUBMISSION_PENDING: 'FSDO_SUBMISSION_PENDING',
    FSDO_SUBMISSION_SUCCESS: 'FSDO_SUBMISSION_SUCCESS',
    FSDO_SUBMISSION_FAILURE: 'FSDO_SUBMISSION_FAILURE',
    FSDO_RESET_SUBMISSION_REQUEST: 'FSDO_RESET_SUBMISSION_REQUEST',
    FSDO_TOGGLE_SUBMIT_VIEW: 'FSDO_TOGGLE_SUBMIT_VIEW',
    FSDO_CHANGE_VALIDATION_STEP: 'FSDO_CHANGE_VALIDATION_STEP',
    FSDO_RESET_SUBMISSION: 'FSDO_RESET_SUBMISSION',
    FSDO_TOGGLE_SUBMISSION_MODAL: 'FSDO_TOGGLE_SUBMISSION_MODAL',
    FSDO_UPDATE_MODAL_CONTENT: 'FSDO_UPDATE_MODAL_CONTENT',
    FSDO_UPDATE_MODAL_PROPS: 'FSDO_UPDATE_MODAL_PROPS'
}
